import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { IRequestOptions } from "../IRequestOptions";
import { tms } from "../tms";

/**
 * 绑定用户设备接口的请求参数
 */
export interface IBindUserDeviceParams extends IRequestParams {
    /**
     * 设备唯一ID
     */
    device_id: string;
}

/**
 * 绑定用户设备接口的返回结果
 */
export interface IBindUserDeviceResult extends IResultContent {
    is_ok: boolean;
    msg: string;
}

/**
 * 绑定用户设备
 * @param opts 请求选项
 * @returns 绑定结果
 */
export async function bindUserDevice(opts: IRequestOptions<IBindUserDeviceParams>) {
    const res = await request<IBindUserDeviceResult>(
        tms.TUserDevice,
        tms.MUserDeviceBindUser,
        opts.params,
        opts.gateway,
        opts.handler
    );
    return res;
}

export default bindUserDevice;
